/**
 * COMMERCE-WORKSPACE-FRAMEWORK-000001 — peer navigation for commerce desks.
 * Deep links carry full Global Filter Engine context (GLOBAL-FILTER-ENGINE-000001).
 */
import { Link } from 'react-router-dom';
import { useGlobalFilterOptional } from '../global-filter';
import type { CommerceDomain, CommercePeerId } from './types';
import { peersForDomain } from './routing';

export function CommercePeerNav({
  domain,
  peers,
}: {
  domain: CommerceDomain;
  peers?: CommercePeerId[];
}) {
  const list = peersForDomain(domain, peers);
  const gfe = useGlobalFilterOptional();
  return (
    <nav className="flex flex-wrap gap-1.5" aria-label="Commerce peer workspaces">
      {list.map((p) => {
        const isActive = p.id === domain;
        const to = gfe
          ? gfe.buildLink(p.path, undefined, {
              connection: gfe.context.connectionId ?? undefined,
              q: gfe.context.search || undefined,
            })
          : p.path;
        return (
          <Link
            key={p.path}
            to={to}
            className={`min-h-11 rounded-[var(--shell-radius-md)] px-3 py-2 text-sm font-medium transition-colors duration-[var(--shell-motion-fast)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--shell-focus-ring)] ${
              isActive
                ? 'bg-[var(--shell-fg)] text-[var(--shell-canvas)]'
                : 'bg-[var(--shell-hover)] text-[var(--shell-fg-muted)] hover:text-[var(--shell-fg)]'
            }`}
            aria-current={isActive ? 'page' : undefined}
          >
            {p.label}
          </Link>
        );
      })}
    </nav>
  );
}
